/**
 * Coups de pouce — Attendu 680 « Calculer des probabilités (équiprobabilité) ».
 *
 * Clé persistée au niveau EXERCICE (calcul_probabilite_equiprobabilite…) :
 * une entrée sert tous les formats d'un exercice, avec VARIANTES par motif
 * pour les formats dont la compétence diffère (écritures, comparaison).
 *
 * Règle absolue : l'aide porte sur d'AUTRES valeurs que celles que le
 * générateur peut tirer (urne de 4 boules : les totaux tirés vont de 5 à 20 ;
 * cible 1/10 : absente des cibles du QCM multiple).
 * Emphase : **texte** (pas de HTML brut). Pas de tiret cadratin.
 */

// ── Défaut : « favorables sur total » (id cp680play1) ──
// Urne de 4 boules (3 bleues, 1 rouge) : total hors plage du générateur.
const SVG_FAVORABLES_ANIM = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 216" role="img"
     aria-label="Une urne de 4 boules : 3 bleues et 1 rouge. On compte les bleues : une, deux, trois. On compte toutes les boules : quatre. La probabilité de tirer une bleue est 3 sur 4">
  <g id="cp680play1" style="cursor:pointer">
    <title>Lancer l'animation</title>
    <rect x="266" y="4" width="86" height="24" rx="12" fill="#1E3A8A"/>
    <path d="M278 10 L278 22 L288 16 Z" fill="#ffffff"/>
    <text x="322" y="20" font-size="12" font-weight="600" fill="#ffffff" text-anchor="middle" font-family="system-ui,sans-serif">Lancer</text>
  </g>
  <text x="8" y="20" font-size="13" font-weight="600" fill="#64748b" font-family="system-ui,sans-serif">Tirer une boule bleue :</text>
  <!-- les 4 boules -->
  <circle cx="60" cy="70" r="14" fill="#378ADD"/>
  <circle cx="104" cy="70" r="14" fill="#378ADD"/>
  <circle cx="148" cy="70" r="14" fill="#dc2626"/>
  <circle cx="192" cy="70" r="14" fill="#378ADD"/>
  <!-- comptage des favorables (bleues) -->
  <text x="60" y="44" font-size="13" font-weight="700" fill="#378ADD" text-anchor="middle" opacity="0" font-family="system-ui,sans-serif">1<animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.25s" begin="cp680play1.click+0.4s" fill="freeze"/></text>
  <text x="104" y="44" font-size="13" font-weight="700" fill="#378ADD" text-anchor="middle" opacity="0" font-family="system-ui,sans-serif">2<animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.25s" begin="cp680play1.click+0.8s" fill="freeze"/></text>
  <text x="192" y="44" font-size="13" font-weight="700" fill="#378ADD" text-anchor="middle" opacity="0" font-family="system-ui,sans-serif">3<animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.25s" begin="cp680play1.click+1.2s" fill="freeze"/></text>
  <g opacity="0">
    <text x="240" y="50" font-size="12" font-weight="700" fill="#378ADD" font-family="system-ui,sans-serif">3 favorables</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.3s" begin="cp680play1.click+1.7s" fill="freeze"/>
  </g>
  <!-- comptage du total -->
  <text x="60" y="102" font-size="12" fill="#0f172a" text-anchor="middle" opacity="0" font-family="system-ui,sans-serif">1<animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.2s" begin="cp680play1.click+2.4s" fill="freeze"/></text>
  <text x="104" y="102" font-size="12" fill="#0f172a" text-anchor="middle" opacity="0" font-family="system-ui,sans-serif">2<animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.2s" begin="cp680play1.click+2.7s" fill="freeze"/></text>
  <text x="148" y="102" font-size="12" fill="#0f172a" text-anchor="middle" opacity="0" font-family="system-ui,sans-serif">3<animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.2s" begin="cp680play1.click+3s" fill="freeze"/></text>
  <text x="192" y="102" font-size="12" fill="#0f172a" text-anchor="middle" opacity="0" font-family="system-ui,sans-serif">4<animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.2s" begin="cp680play1.click+3.3s" fill="freeze"/></text>
  <g opacity="0">
    <text x="240" y="102" font-size="12" font-weight="700" fill="#0f172a" font-family="system-ui,sans-serif">4 boules en tout</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.3s" begin="cp680play1.click+3.7s" fill="freeze"/>
  </g>
  <!-- la fraction s'assemble -->
  <g opacity="0">
    <text x="120" y="140" font-size="14" fill="#0f172a" font-family="system-ui,sans-serif">P(bleue) =</text>
    <text x="205" y="132" font-size="15" font-weight="700" fill="#378ADD" text-anchor="middle" font-family="system-ui,sans-serif">3</text>
    <line x1="192" y1="137" x2="218" y2="137" stroke="#0f172a" stroke-width="1.5"/>
    <text x="205" y="152" font-size="15" font-weight="700" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">4</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp680play1.click+4.4s" fill="freeze"/>
  </g>
  <!-- conclusions -->
  <g opacity="0">
    <rect x="20" y="172" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="180" font-size="13" fill="#0f172a" font-family="system-ui,sans-serif">En haut, les favorables. En bas, le total.</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp680play1.click+5.3s" fill="freeze"/>
  </g>
  <g opacity="0">
    <rect x="20" y="192" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="200" font-size="13" fill="#0f172a" font-family="system-ui,sans-serif">3 bleues sur 4 boules, la probabilité est 3/4.</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp680play1.click+5.9s" fill="freeze"/>
  </g>
</svg>`.trim();

const CP_FAVORABLES = {
    pages: [
        {
            titre: 'La méthode',
            lignes: [
                'Compte les boules **bleues** : ce sont celles qui font gagner. Compte **toutes** les boules. La probabilité s\'écrit **bleues sur total** : ici **3 sur 4**.',
            ],
            svg: SVG_FAVORABLES_ANIM,
        },
    ],
};

// ── Variante QCM multiple : les écritures d'une probabilité (id cp680play2) ──
// Cible 1/10 : absente des cibles du générateur.
const SVG_ECRITURES_ANIM = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 190" role="img"
     aria-label="Une même probabilité s'écrit de plusieurs façons : 1 sur 10, 0,1 et 10 pour cent sont égaux">
  <g id="cp680play2" style="cursor:pointer">
    <title>Lancer l'animation</title>
    <rect x="266" y="4" width="86" height="24" rx="12" fill="#1E3A8A"/>
    <path d="M278 10 L278 22 L288 16 Z" fill="#ffffff"/>
    <text x="322" y="20" font-size="12" font-weight="600" fill="#ffffff" text-anchor="middle" font-family="system-ui,sans-serif">Lancer</text>
  </g>
  <!-- trois cartes -->
  <rect x="24" y="52" width="88" height="56" rx="10" fill="none" stroke="#1E3A8A" stroke-width="2"/>
  <text x="68" y="87" font-size="18" font-weight="700" fill="#1E3A8A" text-anchor="middle" font-family="system-ui,sans-serif">1/10</text>
  <g opacity="0">
    <text x="127" y="86" font-size="16" font-weight="700" fill="#64748b" text-anchor="middle" font-family="system-ui,sans-serif">=</text>
    <rect x="140" y="52" width="88" height="56" rx="10" fill="none" stroke="#1D9E75" stroke-width="2"/>
    <text x="184" y="87" font-size="18" font-weight="700" fill="#1D9E75" text-anchor="middle" font-family="system-ui,sans-serif">0,1</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp680play2.click+0.5s" fill="freeze"/>
  </g>
  <g opacity="0">
    <text x="243" y="86" font-size="16" font-weight="700" fill="#64748b" text-anchor="middle" font-family="system-ui,sans-serif">=</text>
    <rect x="256" y="52" width="88" height="56" rx="10" fill="none" stroke="#F97316" stroke-width="2"/>
    <text x="300" y="87" font-size="18" font-weight="700" fill="#F97316" text-anchor="middle" font-family="system-ui,sans-serif">10 %</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp680play2.click+1.4s" fill="freeze"/>
  </g>
  <g opacity="0">
    <text x="68" y="126" font-size="11" fill="#64748b" text-anchor="middle" font-family="system-ui,sans-serif">1 sur 10</text>
    <text x="184" y="126" font-size="11" fill="#64748b" text-anchor="middle" font-family="system-ui,sans-serif">1 ÷ 10</text>
    <text x="300" y="126" font-size="11" fill="#64748b" text-anchor="middle" font-family="system-ui,sans-serif">10 sur 100</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp680play2.click+2.2s" fill="freeze"/>
  </g>
  <!-- conclusions -->
  <g opacity="0">
    <rect x="20" y="148" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="156" font-size="13" fill="#0f172a" font-family="system-ui,sans-serif">Une même probabilité a plusieurs écritures.</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp680play2.click+3.1s" fill="freeze"/>
  </g>
  <g opacity="0">
    <rect x="20" y="168" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="176" font-size="13" fill="#0f172a" font-family="system-ui,sans-serif">Vérifie chaque écriture : vaut-elle le même nombre ?</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp680play2.click+3.7s" fill="freeze"/>
  </g>
</svg>`.trim();

const CP_ECRITURES_PAGES = [
    {
        titre: 'La méthode',
        lignes: [
            'Fraction, nombre décimal, pourcentage : ce sont des **écritures différentes** du même nombre.',
        ],
        svg: SVG_ECRITURES_ANIM,
    },
];

// ── Variante ordonner : comparer avec les repères (id cp680play3) ──
const SVG_COMPARER_ANIM = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 196" role="img"
     aria-label="Une droite de 0 à 1 : 2 sur 10 se place près de 0, 9 sur 10 près de 1, donc 2 sur 10 est plus petit que 9 sur 10">
  <g id="cp680play3" style="cursor:pointer">
    <title>Lancer l'animation</title>
    <rect x="266" y="4" width="86" height="24" rx="12" fill="#1E3A8A"/>
    <path d="M278 10 L278 22 L288 16 Z" fill="#ffffff"/>
    <text x="322" y="20" font-size="12" font-weight="600" fill="#ffffff" text-anchor="middle" font-family="system-ui,sans-serif">Lancer</text>
  </g>
  <!-- droite 0 - 1/2 - 1 -->
  <line x1="30" y1="100" x2="330" y2="100" stroke="#0f172a" stroke-width="2"/>
  <line x1="30" y1="93" x2="30" y2="107" stroke="#0f172a" stroke-width="2"/>
  <line x1="180" y1="93" x2="180" y2="107" stroke="#0f172a" stroke-width="2"/>
  <line x1="330" y1="93" x2="330" y2="107" stroke="#0f172a" stroke-width="2"/>
  <text x="30" y="124" font-size="13" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">0</text>
  <text x="180" y="124" font-size="13" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">1/2</text>
  <text x="330" y="124" font-size="13" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">1</text>
  <!-- 2/10 tombe près de 0 -->
  <g opacity="0">
    <text x="90" y="66" font-size="13" font-weight="700" fill="#1D9E75" text-anchor="middle" font-family="system-ui,sans-serif">2/10</text>
    <circle cx="90" cy="100" r="6" fill="#1D9E75">
      <animate attributeName="cy" values="74;100" keyTimes="0;1" dur="0.4s" begin="cp680play3.click+0.5s" fill="freeze"/>
    </circle>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.3s" begin="cp680play3.click+0.4s" fill="freeze"/>
  </g>
  <!-- 9/10 tombe près de 1 -->
  <g opacity="0">
    <text x="300" y="66" font-size="13" font-weight="700" fill="#F97316" text-anchor="middle" font-family="system-ui,sans-serif">9/10</text>
    <circle cx="300" cy="100" r="6" fill="#F97316">
      <animate attributeName="cy" values="74;100" keyTimes="0;1" dur="0.4s" begin="cp680play3.click+1.4s" fill="freeze"/>
    </circle>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.3s" begin="cp680play3.click+1.3s" fill="freeze"/>
  </g>
  <g opacity="0">
    <text x="180" y="46" font-size="14" font-weight="700" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">2/10 &lt; 9/10</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp680play3.click+2.3s" fill="freeze"/>
  </g>
  <!-- conclusions -->
  <g opacity="0">
    <rect x="20" y="152" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="160" font-size="13" fill="#0f172a" font-family="system-ui,sans-serif">Même dénominateur, on compare les numérateurs.</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp680play3.click+3.2s" fill="freeze"/>
  </g>
  <g opacity="0">
    <rect x="20" y="172" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="180" font-size="13" fill="#0f172a" font-family="system-ui,sans-serif">Sinon, place chaque fraction par rapport à 0, 1/2 et 1.</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp680play3.click+3.8s" fill="freeze"/>
  </g>
</svg>`.trim();

const CP_COMPARER_PAGES = [
    {
        titre: 'La méthode',
        lignes: [
            'Écris chaque probabilité en fraction, puis **compare** : même dénominateur, ou position par rapport à **0, 1/2 et 1**.',
        ],
        svg: SVG_COMPARER_ANIM,
    },
];

// ── Variante saisie : la fraction SIMPLIFIÉE (id cp680play4) ──
// Urne de 4 boules (2 bleues, 2 rouges) : total hors plage, et la fraction
// obtenue (2/4) se simplifie — le contrat du format saisie.
const SVG_SIMPLIFIER_ANIM = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 216" role="img"
     aria-label="Une urne de 4 boules : 2 bleues et 2 rouges. On compte 2 bleues sur 4 boules, la fraction 2 sur 4 se simplifie en divisant le haut et le bas par 2 : cela donne 1 sur 2">
  <g id="cp680play4" style="cursor:pointer">
    <title>Lancer l'animation</title>
    <rect x="266" y="4" width="86" height="24" rx="12" fill="#1E3A8A"/>
    <path d="M278 10 L278 22 L288 16 Z" fill="#ffffff"/>
    <text x="322" y="20" font-size="12" font-weight="600" fill="#ffffff" text-anchor="middle" font-family="system-ui,sans-serif">Lancer</text>
  </g>
  <text x="8" y="20" font-size="13" font-weight="600" fill="#64748b" font-family="system-ui,sans-serif">Tirer une boule bleue :</text>
  <circle cx="60" cy="66" r="14" fill="#378ADD"/>
  <circle cx="104" cy="66" r="14" fill="#dc2626"/>
  <circle cx="148" cy="66" r="14" fill="#378ADD"/>
  <circle cx="192" cy="66" r="14" fill="#dc2626"/>
  <!-- fraction brute -->
  <g opacity="0">
    <text x="80" y="122" font-size="14" fill="#0f172a" font-family="system-ui,sans-serif">P(bleue) =</text>
    <text x="165" y="114" font-size="15" font-weight="700" fill="#378ADD" text-anchor="middle" font-family="system-ui,sans-serif">2</text>
    <line x1="152" y1="119" x2="178" y2="119" stroke="#0f172a" stroke-width="1.5"/>
    <text x="165" y="134" font-size="15" font-weight="700" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">4</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp680play4.click+0.5s" fill="freeze"/>
  </g>
  <!-- flèches ÷2 -->
  <g opacity="0">
    <path d="M186 108 Q206 100 226 108" fill="none" stroke="#F97316" stroke-width="1.5"/>
    <text x="206" y="98" font-size="12" font-weight="700" fill="#F97316" text-anchor="middle" font-family="system-ui,sans-serif">÷ 2</text>
    <path d="M186 130 Q206 138 226 130" fill="none" stroke="#F97316" stroke-width="1.5"/>
    <text x="206" y="152" font-size="12" font-weight="700" fill="#F97316" text-anchor="middle" font-family="system-ui,sans-serif">÷ 2</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp680play4.click+1.5s" fill="freeze"/>
  </g>
  <!-- fraction simplifiée -->
  <g opacity="0">
    <text x="238" y="122" font-size="14" font-weight="700" fill="#64748b" font-family="system-ui,sans-serif">=</text>
    <text x="266" y="114" font-size="15" font-weight="700" fill="#1D9E75" text-anchor="middle" font-family="system-ui,sans-serif">1</text>
    <line x1="253" y1="119" x2="279" y2="119" stroke="#1D9E75" stroke-width="1.5"/>
    <text x="266" y="134" font-size="15" font-weight="700" fill="#1D9E75" text-anchor="middle" font-family="system-ui,sans-serif">2</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp680play4.click+2.4s" fill="freeze"/>
  </g>
  <!-- conclusions -->
  <g opacity="0">
    <rect x="20" y="172" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="180" font-size="13" fill="#0f172a" font-family="system-ui,sans-serif">On divise le haut et le bas par le même nombre.</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp680play4.click+3.3s" fill="freeze"/>
  </g>
  <g opacity="0">
    <rect x="20" y="192" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="200" font-size="13" fill="#0f172a" font-family="system-ui,sans-serif">2/4 = 1/2 : c'est la fraction simplifiée.</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp680play4.click+3.9s" fill="freeze"/>
  </g>
</svg>`.trim();

const CP_SIMPLIFIER_PAGES = [
    {
        titre: 'La méthode',
        lignes: [
            'Compte les boules **bleues**, puis **toutes** les boules : ici **2 sur 4**. Ensuite **simplifie** : divise le haut et le bas par le même nombre.',
        ],
        svg: SVG_SIMPLIFIER_ANIM,
    },
];

// ── Fabriquer : trouver le nombre de billes pour une probabilité (id cp680play5) ──
// Sac de 100 billes : les totaux du générateur s'arrêtent à 40.
const SVG_FABRIQUER_ANIM = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 234" role="img"
     aria-label="Un sac de 100 billes, on veut une probabilité de 1 sur 4. La barre de 100 se coupe en 4 parts de 25, une part se colore : il faut 25 billes. Si le total ne se coupe pas en parts égales, la probabilité est impossible">
  <g id="cp680play5" style="cursor:pointer">
    <title>Lancer l'animation</title>
    <rect x="266" y="4" width="86" height="24" rx="12" fill="#1E3A8A"/>
    <path d="M278 10 L278 22 L288 16 Z" fill="#ffffff"/>
    <text x="322" y="20" font-size="12" font-weight="600" fill="#ffffff" text-anchor="middle" font-family="system-ui,sans-serif">Lancer</text>
  </g>
  <text x="8" y="20" font-size="13" font-weight="600" fill="#64748b" font-family="system-ui,sans-serif">100 billes, on veut une probabilité de 1/4</text>
  <!-- la barre des 100 billes -->
  <rect x="30" y="60" width="300" height="30" rx="4" fill="none" stroke="#1E3A8A" stroke-width="2"/>
  <text x="180" y="52" font-size="12" fill="#64748b" text-anchor="middle" font-family="system-ui,sans-serif">100 billes</text>
  <!-- découpe en 4 parts -->
  <line x1="105" y1="58" x2="105" y2="92" stroke="#64748b" stroke-width="1.5" stroke-dasharray="4 3" opacity="0">
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.3s" begin="cp680play5.click+0.5s" fill="freeze"/>
  </line>
  <line x1="180" y1="58" x2="180" y2="92" stroke="#64748b" stroke-width="1.5" stroke-dasharray="4 3" opacity="0">
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.3s" begin="cp680play5.click+0.9s" fill="freeze"/>
  </line>
  <line x1="255" y1="58" x2="255" y2="92" stroke="#64748b" stroke-width="1.5" stroke-dasharray="4 3" opacity="0">
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.3s" begin="cp680play5.click+1.3s" fill="freeze"/>
  </line>
  <!-- les 4 parts de 25 -->
  <g opacity="0">
    <text x="67" y="80" font-size="13" font-weight="700" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">25</text>
    <text x="142" y="80" font-size="13" font-weight="700" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">25</text>
    <text x="217" y="80" font-size="13" font-weight="700" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">25</text>
    <text x="292" y="80" font-size="13" font-weight="700" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">25</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp680play5.click+1.9s" fill="freeze"/>
  </g>
  <!-- on prend 1 part -->
  <g opacity="0">
    <rect x="31" y="61" width="73" height="28" rx="3" fill="#378ADD" opacity="0.35"/>
    <text x="67" y="110" font-size="12" font-weight="700" fill="#378ADD" text-anchor="middle" font-family="system-ui,sans-serif">1 part sur 4</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp680play5.click+2.6s" fill="freeze"/>
  </g>
  <!-- la division -->
  <text x="180" y="138" font-size="15" font-weight="700" fill="#0f172a" opacity="0" text-anchor="middle" font-family="system-ui,sans-serif">100 ÷ 4 = 25 billes<animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp680play5.click+3.4s" fill="freeze"/></text>
  <!-- conclusions -->
  <g opacity="0">
    <rect x="20" y="168" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="176" font-size="13" fill="#0f172a" font-family="system-ui,sans-serif">Le bas de la fraction dit en combien de parts couper.</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp680play5.click+4.3s" fill="freeze"/>
  </g>
  <g opacity="0">
    <rect x="20" y="188" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="196" font-size="13" fill="#0f172a" font-family="system-ui,sans-serif">1/4 de 100, cela fait 25 billes.</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp680play5.click+4.9s" fill="freeze"/>
  </g>
  <g opacity="0">
    <rect x="20" y="208" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="216" font-size="13" fill="#0f172a" font-family="system-ui,sans-serif">Si le total ne se coupe pas en parts égales, la probabilité est impossible.</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp680play5.click+5.5s" fill="freeze"/>
  </g>
</svg>`.trim();

const CP_FABRIQUER = {
    pages: [
        {
            titre: 'La méthode',
            lignes: [
                'Partage le total en **autant de parts que le bas** de la fraction. Prends **autant de parts que le haut**.',
            ],
            svg: SVG_FABRIQUER_ANIM,
        },
    ],
};

const CP_680 = {
    calcul_probabilite_equiprobabilite: {
        variantes: [
            { motif: 'en valeur exacte ou approchée', pages: CP_ECRITURES_PAGES },
            { motif: 'Range les probabilités', pages: CP_COMPARER_PAGES },
            { motif: 'fraction simplifiée', pages: CP_SIMPLIFIER_PAGES },
        ],
        defaut: CP_FAVORABLES,
    },
    // Exercice 2 (comparer, 3 formats) : même compétence que la variante
    // « comparer » du calcul — la page est réutilisée telle quelle.
    comparer_probabilites_tirages: { pages: CP_COMPARER_PAGES },
    // Exercice 3 (fabriquer, 3 formats) : la direction inverse.
    fabriquer_situation_probabilite: CP_FABRIQUER,
};

export default CP_680;
